import React from 'react';
import { Placeholder } from 'react-bootstrap';

const INFLUENCERS = 2;
const PLATFORMS_PER_INFLUENCER = 2;

interface IProps {
    hideCosts: boolean;
}

export function DetailedPerPlatformTableSkeletonBody({ hideCosts }: IProps) {
    // Reported, impressions, reach, engagements, clicks, ER (+ reach CPM i costs)
    const valueColumns = hideCosts ? 6 : 8;
    const totalColumns = valueColumns + 2;

    const valueCells = (keyPrefix: string) =>
        Array.from({ length: valueColumns }).map((_, i) => (
            <td key={`${keyPrefix}-${i}`} className="px-0 py-2 text-center">
                <Placeholder className="skeleton skeleton-table-cell" />
            </td>
        ));

    return (
        <Placeholder as="tbody" animation="glow" aria-hidden="true">
            {Array.from({ length: INFLUENCERS }).map((_, i) => (
                <React.Fragment key={i}>
                    <tr className="bg-muted border-bottom border-top">
                        <td className="px-0 py-2" colSpan={totalColumns}>
                            <div className="d-flex align-items-center pl-2">
                                <Placeholder className="skeleton skeleton-influencer-avatar" />
                                <Placeholder className="skeleton skeleton-table-name ml-2" />
                            </div>
                        </td>
                    </tr>
                    {Array.from({ length: PLATFORMS_PER_INFLUENCER }).map((_, j) => (
                        <tr key={j} className="border-bottom">
                            <td />
                            <td>
                                <div className="d-flex align-items-center">
                                    <Placeholder className="skeleton skeleton-platform-icon" />
                                    <Placeholder className="skeleton skeleton-table-cell ml-2" />
                                </div>
                            </td>
                            {valueCells(`${i}-${j}`)}
                        </tr>
                    ))}
                </React.Fragment>
            ))}
            <tr className="border-top border-bottom bg-muted">
                <td className="pl-2">
                    <Placeholder className="skeleton skeleton-table-cell" />
                </td>
                <td />
                {valueCells('total')}
            </tr>
        </Placeholder>
    );
}
